// extracted by mini-css-extract-plugin
export default {"barContainer":"ProgressBar_barContainer__4KHbZ","bar":"ProgressBar_bar__yespg"};